import { List, Page } from '@oliasoft-open-source/react-ui-library';
import { useTranslation } from 'react-i18next';
import translations from 'client/internationalization/translation-map.json';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { routes } from 'client/views/navigation/routes/routes';
import { GeneralSettings } from './general-settings/general-settings';
import { FeatureFlagSettings } from './feature-flag-settings/feature-flag-settings';
import { GeneralSettingsPageTabIds, SettingsPageIds } from './settings-constants';

import styles from './user-settings.module.css';

export const VIEW_NAME_COMPONENT_MAP = {
  [SettingsPageIds.General]: GeneralSettings,
  [SettingsPageIds.FeatureFlags]: FeatureFlagSettings,
};

export const UserSettings = () => {
  const navigate = useNavigate();
  const { companyId, settingsPageId } = useParams();
  const { t } = useTranslation();

  const modules = [
    {
      name: t(translations.settings_generalTab),
      id: SettingsPageIds.General,
      settingsPageTabId: GeneralSettingsPageTabIds.UserAccount,
      testId: 'user-settings-list-general',
    },
    {
      name: t(translations.settings_featureFlagsTab),
      id: SettingsPageIds.FeatureFlags,
      settingsPageTabId: '',
      testId: 'user-settings-feature-flags',
    },
  ];

  const settingListItems = modules.map(({
    name, id, settingsPageTabId, testId,
  }) => ({
    id,
    name,
    active: settingsPageId === id,
    testId,
    onClick: () => navigate(generatePath(routes.userSettingsTabs.pattern.path, {
      companyId, settingsPageId: id, settingsPageTabId,
    })),
  }));

  const settingsList = {
    name: t(translations.settings_userSettings),
    items: settingListItems,
  };

  const renderMainView = () => {
    const View = VIEW_NAME_COMPONENT_MAP[settingsPageId as SettingsPageIds || SettingsPageIds.General];
    return <View />;
  };

  return (
    <Page padding={false} scroll={false}>
      <div className={styles.wrapper}>
        <div className={styles.sidebar}>
          <List list={settingsList} drawer testId="user-settings-list" />
        </div>
        <div className={styles.content}>
          <div className={styles.tab}>{ renderMainView() }</div>
        </div>
      </div>
    </Page>
  );
};
